import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { EmailFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkEmailPOSTErrorResponse, ParkEmailPOSTRequest, ParkEmailPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const sendByEmail = async (requestData: ParkEmailPOSTRequest): Promise<ParkEmailPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkEmailPOSTSuccessResponse>("/email", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkEmailPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: EmailFailReason };
  }
};
